import overViewActive from "../assets/svgIcons/overviewActive.svg";
import OverViewIcon from "../Icons/OverIcon";

export const navigation: any = [
  {
    name: "Dashboard",
    href: "/",
    icon: "",
    children: [
      {
        name: "Overview",
        href: "/",
        icon: OverViewIcon,
        activeIcon: overViewActive,
      },
    ],
  },
  {
    name: "Operations",
    href: "/",
    icon: "",
    children: [
      {
        name: "Consignment",
        href: "/order?limit=10&page=0",
        icon: OverViewIcon,
        activeIcon: OverViewIcon,
        children: [
          {
            name: "Orders",
            href: "/order?limit=10&page=0",
            icon: OverViewIcon,
            activeIcon: OverViewIcon,
          },
        ],
      },
      {
        name: "Manifest",
        href: "/manifest?limit=10&page=0",
        icon: OverViewIcon,
        activeIcon: OverViewIcon,
        children: [],
      },
      {
        name: "Runsheet",
        href: "/runsheet?limit=10&page=0",
        icon: OverViewIcon,
        activeIcon: OverViewIcon,
        children: [],
      },
      {
        name: "Ticket",
        href: "/ticket?limit=10&page=0",
        icon: OverViewIcon,
        activeIcon: OverViewIcon,
        children: [],
      },
      {
        name: "KM Record",
        href: "/km-record?limit=10&page=0",
        icon: OverViewIcon,
        activeIcon: OverViewIcon,
        children: [],
      },
    ],
  },
  {
    name: "User Management",
    href: "/",
    icon: "",
    children: [
      {
        name: "Customer",
        href: "/customer?limit=10&page=0",
        icon: OverViewIcon,
        activeIcon: OverViewIcon,
      },
      {
        name: "Staff",
        href: "/staff?limit=10&page=0",
        icon: OverViewIcon,
        activeIcon: OverViewIcon,
      },
      {
        name: "Rider/Driver",
        href: "/rider?limit=10&page=0",
        icon: OverViewIcon,
        activeIcon: OverViewIcon,
      },
      {
        name: "Merchant",
        href: "/merchant?limit=10&page=0",
        icon: OverViewIcon,
        activeIcon: OverViewIcon,
      },
    ],
  },
  {
    name: "Finance",
    href: "/",
    icon: "",
    children: [
      {
        name: "Overview",
        href: "/finance-overview",
        icon: OverViewIcon,
        activeIcon: OverViewIcon,
      },
      {
        name: "Invoice",
        href: "/invoice?limit=10&page=0",
        icon: OverViewIcon,
        activeIcon: OverViewIcon,
      },
    ],
  },
  {
    name: "Administration",
    href: "/",
    icon: "",
    children: [
      {
        name: "Settings",
        href: "/settings",
        icon: OverViewIcon,
        activeIcon: OverViewIcon,
      },
      {
        name: "Users",
        href: "/users?limit=10&page=0",
        icon: OverViewIcon,
        activeIcon: OverViewIcon,
      },
      {
        name: "Roles",
        href: "/roles?limit=10&page=0",
        icon: OverViewIcon,
        activeIcon: OverViewIcon,
      },
    ],
  },
];